import axios from "axios";
import apiURL from "./apiURL";
import { toast } from "react-toastify";
import { listStorageKeys } from "../helpers/utils";

const API_URL = apiURL("authentication");

const register = (endpoint, body) => {
  const endpointClone = endpoint ? endpoint : "api_user";

  return axios.post(API_URL + endpointClone, body);
};

const CustomRegister = (body) => {
  return axios.post(API_URL + "api_user", body);
};

const login = (body) => {
  return axios
    .post(
      API_URL + "login",
      body,
      { withCredentials: true } //with credentials is used here to store cookies recived in response
    )
    .then((response) => {
      return response.data;
    });
};

const apiPlans = (display) => {
  return axios
    .get(API_URL + `api_plan?displayOnSignup=${display}`)
    .then((response) => {
      return response.data;
    });
};
const AllApiPlans = () => {
  return axios.get(API_URL + `api_plan?displayOnSignup`).then((response) => {
    return response.data;
  });
};
const PMSesLogin = (email) => {
  return axios
    .post(API_URL + "pms_page_authentication", {
      email,
    })
    .then((response) => {
      return response.data;
    });
};

const PMSesAccessCodeVerification = (code, email) => {
  return axios
    .post(
      API_URL + "verify_pms_page_code",
      {
        code,
        email,
      },
      { withCredentials: true }
    )
    .then((response) => {
      return response.data;
    });
};

const verify = (body) => {
  return axios
    .post(API_URL + "user_verify", body, { withCredentials: true })
    .then((response) => {
      return response.data;
    });
};

const whoisme = () => {
  return axios
    .get(API_URL + "whoisme", { withCredentials: true })
    .then((response) => {
      return response.data;
    });
};

const get_store_data = (apiParam) => {
  return axios
    .get(API_URL + "get_store_data", {
      params: apiParam,
    })
    .then((response) => {
      return response.data;
    });
};

const authenticateUser = (body) => {
  return axios.post(
    API_URL + "2fa_code",
    body,
    { withCredentials: true } //with credentials is used here to store cookies recived in response
  );
  // .then((response) => {
  //   return response.data;
  // });
};

const logout = (isApiPlus = false,isWantToRedirect=true) => {
  const localStorageKeys = listStorageKeys("local");
  const sessionStorageKeys = listStorageKeys("");
  // Redirection
  if (isApiPlus) {
    let getPastedLink = sessionStorage.getItem("api_plus_pasted_link");
    if (sessionStorage.getItem("pastedLinkCount") !== "1") {
      getPastedLink = window.location.href;
    }

    axios
      .get(API_URL + "logout", { withCredentials: true })
      .then((response) => {})
      .catch((error) => toast.error(error));
    if (isWantToRedirect) {
      window.location.assign(getPastedLink);
    }
    const excludeKeys = [
      "api_plus_plus",
      "pastedLinkCount"
    ];
    sessionStorageKeys.map((item) => {
      if (!excludeKeys.includes(item)) {
        sessionStorage.removeItem(item);
      }
    });
    localStorageKeys.map((item) => {
      if (!excludeKeys.includes(item)) {
        localStorage.removeItem(item);
      }
    });
  } else {
    // API Call for Logout
    axios
      .get(API_URL + "logout", { withCredentials: true })
      .then((response) => {})
      .catch((error) => toast.error(error));
    sessionStorageKeys.map((item) => {     
        sessionStorage.removeItem(item);      
    });
    localStorageKeys.map((item) => {
        localStorage.removeItem(item);      
    });
    window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
    // Storage Event Dispatch
    const storageEvent = new StorageEvent("storage", {
      key: "isLoggedIn",
      newValue: JSON.stringify(false),
    });
    window.dispatchEvent(storageEvent);
  }
};

const getCurrentUser = () => {
  //return JSON.parse(loginUserDetails);
  return JSON.parse(localStorage.getItem("user"));
};

const addTeamMember = (body) => {
  return axios.post(API_URL + "add_team_member", body).then((response) => {
    return response.data;
  });
};

const unsubscribeCall = (body) => {
  return axios.post(API_URL + "unsubscribe", body).then((response) => {
    return response.data;
  });
};
const llmTrackingCall = (body) => {
  return axios.post(API_URL + "llm_page_tracking", body).then((response) => {
    return response.data;
  });
};
const dentalllmTrackingCall = (body) => {
  return axios
    .post(API_URL + "dental_llm_page_tracking", body)
    .then((response) => {
      return response.data;
    });
};
const forgetPassword = async (endPoint, body) => {
  const response = await axios.put(API_URL + endPoint, body);
  return response;
};
const GetUserDetails = async (endPoint, body) => {
  const response = await axios.post(API_URL + endPoint, body);
  return response;
};
const Get2FAQuestions = async (endPoint, body) => {
  const response = await axios.post(API_URL + endPoint, body);
  return response;
};
const POST2FAQuestions = async (endPoint, body) => {
  const response = await axios.post(API_URL + endPoint, body);
  return response;
};
const POSTMobileCode = async (endPoint, body) => {
  const response = await axios.post(API_URL + endPoint, body, { withCredentials: true });
  return response;
};
const GETEmailVerify = async (endPoint, body) => {
  const response = await axios.post(API_URL + endPoint, body);
  return response;
};
const RegisterTeamMember = (endPoint, body) => {
  return axios.post(API_URL + endPoint, body).then((response) => {
    return response.data;
  });
};

const PostErrorBoundaries = (body) => {
  return axios.post(API_URL + "portal_error", body).then((response) => {
    return response.data;
  });
};

window.addEventListener("beforeunload", () => {
  // Increment the counter on each refresh
  sessionStorage.removeItem("publish-app-details");
});
export default {
  register,
  login,
  PMSesLogin,
  PMSesAccessCodeVerification,
  verify,
  whoisme,
  logout,
  getCurrentUser,
  get_store_data,
  addTeamMember,
  unsubscribeCall,
  forgetPassword,
  llmTrackingCall,
  dentalllmTrackingCall,
  GetUserDetails,
  RegisterTeamMember,
  apiPlans,
  PostErrorBoundaries,
  authenticateUser,
  CustomRegister,
  AllApiPlans,
  Get2FAQuestions,
  POST2FAQuestions,
  POSTMobileCode,
  GETEmailVerify,
};